import React, { useState } from 'react';
import Navbar from '../assets/navbar';
import { Navigate } from "react-router-dom";
import { selectUser, signupUser, loginUser } from "../reducers/userSlice"
import { useAppSelector, useAppDispatch } from '../hooks'
import loginReq from '../components/loginReq';


import {
    Flex,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Spacer,
    Box,
    FormControl,
    InputRightElement,
    Alert,
    AlertIcon,
    Image,
    Text,
  } from "@chakra-ui/react";
import { useDispatch } from 'react-redux';


// function userlogin(){
//     const user = useAppSelector(selectUser);
//     const dispatch = useAppDispatch();
// }

function Alerts() {
  const user = useAppSelector(selectUser);
  if (user.error != ''){
    return (
      <>
      <Alert status="error">
        {user.error}
      </Alert>
      <Text> </Text>
      </>
    )
  }
  if (user.status != ""){
    if (user.status != "idle"){
      return (
        <>
        <Alert status="success">
          {user.status}
        </Alert>
        </>
      )
    }
}
  return (
  <>
  <Text></Text>
  </>
  )

}

export default function SignupPage(){
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();
    
    const [reqDataState, setData] = useState({
        signupkey:"",
        
        username: "",
        password: "",
        passwordVerify: "",
      });


    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setData({ ...reqDataState});
        
		try {
			// First: signup
			const signupPayload = {
				username: reqDataState.username,
				signupKey:reqDataState.signupkey,
				password: reqDataState.password,
				passwordVerify:reqDataState.passwordVerify, 
			}
			await dispatch(signupUser(JSON.stringify(signupPayload))).unwrap()

			// Second: login
			const loginPayload = {
				username: reqDataState.username,
				password: reqDataState.password
			}
			await dispatch(loginUser(JSON.stringify(loginPayload)))
			.unwrap()
		} catch (err: any) {
			console.error("signup/login failed", err)
		}
      };  

    const changeHandler = (e: { target: { name: string; value: string; }; }) => {
        if (e.target.name === "username") {
          setData({ ...reqDataState, [e.target.name]: e.target.value.trim() });
        } else {
          setData({ ...reqDataState, [e.target.name]: e.target.value });
        }
      };

      if (user.loggedIn) {
        return <Navigate to="/SettingsPage" />;
      }
    return (
        <>
        <Navbar/>
        <Flex 
        flexDirection="column"
        width="100%"
        height="85vh"
        justifyContent="center"
        alignItems="center"
        marginBottom="100px"  
        >
            <Stack
            flexDir="column"
            mb="2"
            justifyContent="center"
            alignItems="center"
            >
            <Box minW={{ base: "90%", md: "200px" }}>
                <Image src="logo_nav.svg" />
            </Box>
        <Text
          marginBottom="10px"
          fontSize="30px"
          fontWeight="bold"
          color="#211a52"
        >
          Signup
        </Text>
        <Box minW={{ base: "90%", md: "468px" }}>
            {/* <form onSubmit={()=>dispatch(login())}> */}
            <form onSubmit={handleSubmit}>
                <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="md"
                >
                <FormControl>
                <InputGroup>
                    <Input mb={2}
                    type="text"
                    name="signupkey"
                    placeholder="Signup key"
                    onChange={changeHandler}
                    id='signupkeySignup'
                  />
                    </InputGroup>


                    <InputGroup>
                    <Input mb={2}
                    type="text"
                    name="username"
                    placeholder="Username"
                    onChange={changeHandler}
                    id='username'
                  />
                    </InputGroup>
                    <InputGroup mb={2}>
                        <Input
                        type="password"
                        placeholder="Password"
                        name="password"
                        id="password"
                        onChange={changeHandler}
                        />
                        
                    </InputGroup>

                    <InputGroup>
                        <Input
                        type="password"
                        placeholder="Repeat Password"
                        name="passwordVerify"
                        id="passwordVerify"
                        onChange={changeHandler}
                        />
                    </InputGroup>
                </FormControl>
                <Button
                
                type="submit"
                variant="solid"
                backgroundColor="#211a52"
                color="white"
                width="full"
              >
                Signup
              </Button>
                </Stack>
            </form>
            <Alerts/>
        </Box>
            </Stack>
        </Flex>
        </>
    );
}
